import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';


@Component({
  selector: 'rr-range-control',
  standalone: false,

  templateUrl: './range-control.component.html',
  styleUrl: './range-control.component.scss'
})
export class RangeControlComponent {
  @Input() label: string = '';
  @Input() leftLabel: string = '';
  @Input() rightLabel: string = '';
  @Input() startPosition: 'left' | 'middle' | 'right' = 'middle';
  @Input() icon = '';

  @Output() valueChange = new EventEmitter<number>();

  value: number = 0;


  ngOnInit(){
    switch(this.startPosition) {
      case 'middle':
        this.value = 50;
        break;
      case 'right':
        this.value = 100;
        break;
      default:
        this.value = 0;
    }
  }

  onChange() {
    this.valueChange.emit(this.value);
  }

}
